<div class="panel panel-info height:100%; overflow-y: auto;">
  <div class="panel-heading">
    <h5 style="display: inline-block">
      <span [ngClass]="textColor">{{ presetName }}</span>
    </h5>
    <div class="pull-right btn-toolbar">
      <div class="btn-group btn-group-sm">
        <button
          type="button"
          class="btn btn-primary"
          title="Clone Preset"
          (click)="ClonePreset(presetId)"
        >
          <span data-toggle="tooltip" class="fa fa-lg fa-files-o"></span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          title="Delete Preset"
          (click)="DeletePreset(presetId)"
        >
          <span data-toggle="tooltip" class="fa fa-lg fa-trash-o"></span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          title="Expand Preset"
          (click)="getPresetDocuments(presetId)"
        >
          <span
            data-toggle="tooltip"
            class="fa fa-lg fa-chevron-down"
            [class.fa-chevron-down]="!documentsVisible"
            [class.fa-chevron-up]="documentsVisible"
          ></span>
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <div class="panel-collapse collapse" [class.in]="documentsVisible">
    <div *ngIf="processing" class="list-group">
      <i class="fa fa-spinner fa-spin"></i> Processing...
    </div>
    <div
      class="panel-body"
      *ngIf="documentsVisible && !processing"
      [attr.data-preset-id]="presetId"
    >
      <div>
        <div
          class="list-group"
          cdkDropList
          (cdkDropListDropped)="transferDataSuccess($event)"
        >
          <div *ngIf="Document.length === 0" class="list-group-item text-muted">
            No documents. Drag here to add.
          </div>
          <div class="list-group-item" *ngFor="let document of Document">
            <div class="row">
              <div class="col-md-10">{{ document.FileName }}</div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  title="Delete Preset Document"
                  (click)="DeletePresetDocument(presetId, document.Id)"
                >
                  <span data-toggle="tooltip" class="fa fa-minus"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
